import React from 'react';
import { motion } from 'framer-motion';

const kpiData = [
  {
    icon: '🏆',
    stat: '35+',
    caption: 'év tapasztalat',
  },
  {
    icon: '🏭',
    stat: '1500 m²',
    caption: 'műhely és üzlet',
  },
  {
    icon: '📐',
    stat: '3D',
    caption: 'tervezés',
  },
  {
    icon: '🛠️',
    stat: '2018',
    caption: 'asztalos műhely',
  },
];

export default function KPIGrid() {
  return (
    <section className="py-16 md:py-24 bg-[var(--color-bg)]">
      <div className="mx-auto max-w-[var(--container-max)] px-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {kpiData.map((kpi, index) => (
            <motion.div
              key={index}
              initial={false}
              className="bg-white rounded-2xl p-6 md:p-8 text-center shadow-[var(--shadow-subtle)] md:hover:shadow-[var(--shadow-md)] md:hover:-translate-y-1 transition-all duration-200"
            >
              <div className="text-4xl md:text-5xl mb-4">{kpi.icon}</div>
              <div className="text-3xl md:text-4xl font-bold text-[var(--color-text-primary)] mb-2 font-[var(--font-serif)]">
                {kpi.stat}
              </div>
              <div className="text-sm md:text-base text-[var(--color-text-secondary)] font-medium">
                {kpi.caption}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}

